const initialState = {
  contractList: [],
  nonContractList: [],
  vehicleAllContracts: [],
  refreshUpliftStatus: "",
  contractType: "nonContracted",
};
export default initialState;
